import React, { useCallback, useState } from 'react';
import { toast } from 'sonner';
import { Header } from './components/site/Header';
import { Hero } from './components/site/Hero';
import { SizesSection } from './components/site/SizesSection';
import { HowItWorks } from './components/site/HowItWorks';
import { WhyUs } from './components/site/WhyUs';
import { FAQ } from './components/site/FAQ';
import { Footer } from './components/site/Footer';
import { ReservationFlow } from './components/reserve/ReservationFlow';
import type { ReservationState } from './components/reserve/types';
import { Toaster } from './components/ui/Sonner';
export function App() {
  const [reserveOpen, setReserveOpen] = useState(false);
  const [initialSizeId, setInitialSizeId] = useState<string | null>(null);
  const openReserve = useCallback((sizeId: string | null = null) => {
    setInitialSizeId(sizeId);
    setReserveOpen(true);
  }, []);
  const handleComplete = useCallback((state: ReservationState) => {
    toast.success('Reservation confirmed', {
      description: "We've emailed your confirmation and will call to schedule delivery."
    });
    void state;
  }, []);
  return <div className="min-h-full w-full bg-background text-foreground" data-id="element-0">
      <Header onReserve={() => openReserve(null)} data-id="element-1" />

      <main data-id="element-2">
        <Hero onReserve={() => openReserve(null)} data-id="element-3" />
        <SizesSection onReserve={sizeId => openReserve(sizeId)} data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <WhyUs data-id="element-6" />
        <FAQ data-id="element-7" />
      </main>

      <Footer onReserve={() => openReserve(null)} data-id="element-8" />

      <ReservationFlow open={reserveOpen} initialSizeId={initialSizeId} onClose={() => setReserveOpen(false)} onComplete={handleComplete} data-id="element-9" />

      <Toaster richColors position="top-center" data-id="element-10" />
    </div>;
}